import { render, staticRenderFns } from "./centurion-footer.vue?vue&type=template&id=2a79388e&scoped=true&"
import script from "./centurion-footer.vue?vue&type=script&lang=js&"
export * from "./centurion-footer.vue?vue&type=script&lang=js&"
import style0 from "./centurion-footer.vue?vue&type=style&index=0&id=2a79388e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a79388e",
  null
  
)

export default component.exports